import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SidebarStateService } from '../sidebar/sidebar-state.service';

@Component({
  selector: 'nsp-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive],
})
export class SidebarItemComponent {
  state = inject(SidebarStateService);

  icon = input<string>();
  label = input<string>();
  url = input<string | undefined>();
  paths = computed(() => (this.url() === '/' ? 'exact' : 'subset'));
  itemClick = output<void>();

  minimised = this.state.minimised;

  onItemClick = () => this.itemClick.emit();
}
